module.exports = __webpack_public_path__ + "img/1.8929e081.jpg";